import React from 'react';

export default function Loading({ error }) {
  return (
    <div className="relative h-screen w-screen max-w-[390px] mx-auto overflow-hidden">
      {/* Background Layer */}
      <div className="absolute inset-0 bg-[url('/assets/locations/forestClearing.png')] bg-cover bg-center pointer-events-none" />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/75 to-black/90 pointer-events-none" />

      {/* Content Layer */}
      <div className="relative h-full w-full flex items-center justify-center p-4">
        <div className="text-center">
          {error ? (
            <div 
              className="text-red-400 font-['Quicksand'] text-lg px-6 py-4 
                bg-black/40 rounded-lg border border-red-400/30
                animate-[shake_0.5s_ease-in-out]
                [text-shadow:_0_0_10px_rgba(248,113,113,0.5)]"
            >
              {error}
            </div>
          ) : (
            <div className="flex flex-col items-center space-y-4">
              {/* Loading Spinner */}
              <div 
                className="w-12 h-12 border-4 border-emerald-500/30 
                  border-t-emerald-500 rounded-full
                  animate-[spin_1s_linear_infinite]"
              />
              
              {/* Loading Text */}
              <div 
                className="text-emerald-400 font-['Crimson_Pro'] text-xl
                  animate-[pulse_2s_ease-in-out_infinite]
                  [text-shadow:_0_0_10px_rgba(52,211,153,0.5)]"
              >
                Loading...
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Animations */}
      <style jsx>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-4px); }
          75% { transform: translateX(4px); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.6; }
        }
      `}</style>
    </div>
  );
}
